import { render, staticRenderFns } from "./FormDisclaimer.vue?vue&type=template&id=65fd9388&"
import script from "./FormDisclaimer.vue?vue&type=script&lang=js&"
export * from "./FormDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports